import styles from './admin-bar.module.less';

const AdminBar = ({ className, ...props }) => {
    return (
        <div className={styles.outer}>
            <div className={[className, styles.inner].join(' ')} {...props} />
        </div>
    );
};

export default AdminBar;
